var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.me)?_c('div',[_c('h3',[_vm._v("Actualizaciones para Cyberpuerta")])]):_vm._e(),(!_vm.me)?_c('div',[_c('h3',[_vm._v("No has iniciado sesion")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }